






































import { Component, Prop, Vue } from "vue-property-decorator";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import LoadingButton from "@/components/core/controls/loading-button.component.vue";
import { Fragment } from "vue-fragment";

@Component({
  components: {
    ClipLoader,
    LoadingButton,
    Fragment
  }
})
export default class Subheader extends Vue {
  @Prop() isEditing!: boolean;
  @Prop() onEdit!: () => void;
  @Prop() onSave!: () => Promise<boolean>;
  @Prop() isLoading!: boolean;
  @Prop() onCancel!: () => void;
  @Prop() canEdit!: boolean;
  @Prop() imgSrc!: string;

  @Prop() secondButtonText?: string;
  @Prop() secondButtonAction?: () => Promise<boolean>;
  @Prop() isSecondButtonLoading?: boolean;

  @Prop() leftIconButtonSrc?: string;
  @Prop() leftIconButtonAction?: () => void;

  public save() {
    if (!this.isLoading) {
      this.onSave().then(r => {});
    }
  }

  public saveSecondButton() {
    if (!this.isSecondButtonLoading && this.secondButtonAction) {
      this.secondButtonAction().then(r => {});
    }
  }

  public edit() {
    if (!this.isLoading || !this.isSecondButtonLoading) {
      this.onEdit();
    }
  }

  public cancel() {
    if (!this.isLoading || !this.isSecondButtonLoading) {
      this.onCancel();
    }
  }
}
